import React from 'react'

import { SvgIcon } from '@mui/material'
import { useTheme } from '@mui/material/styles'

export const Icon = props => {
  const { palette } = useTheme()

  return (
    <SvgIcon {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M17.909 6.625a1 1 0 1 1 1.561-1.25c1.48 1.849 2.22 4.07 2.22 6.625 0 2.555-.74 4.776-2.22 6.625a1 1 0 1 1-1.561-1.25c1.188-1.485 1.78-3.263 1.78-5.375 0-2.111-.593-3.89-1.78-5.375z" />
      <path fillRule="evenodd" clipRule="evenodd" d="M15.816 10.447c-.296-.494-.056-1.094.537-1.341.593-.247 1.313-.047 1.61.447.48.802.726 1.62.726 2.447s-.245 1.645-.726 2.447c-.297.494-1.017.694-1.61.447-.593-.247-.833-.847-.537-1.341.32-.532.474-1.046.474-1.553 0-.507-.155-1.021-.474-1.553zM7.47 6.625a1 1 0 0 0-1.561-1.25c-1.48 1.849-2.22 4.07-2.22 6.625 0 2.555.74 4.776 2.22 6.625a1 1 0 1 0 1.561-1.25C6.282 15.89 5.69 14.112 5.69 12c0-2.111.592-3.89 1.78-5.375z" />
      <path fillRule="evenodd" clipRule="evenodd" d="M9.563 10.447c.296-.494.056-1.094-.537-1.341-.593-.247-1.314-.047-1.61.447-.48.802-.727 1.62-.727 2.447s.246 1.645.727 2.447c.296.494 1.017.694 1.61.447.593-.247.833-.847.537-1.341-.32-.532-.474-1.046-.474-1.553 0-.507.155-1.021.474-1.553zM12.69 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
      <path stroke={palette.contrastInverse.active} strokeWidth="2" strokeLinecap="round" d="m3.028 7.543 19.167 9.411" />
      <path stroke={palette.contrastInverse.active} strokeWidth="2.25" strokeLinecap="round" d="m3.195 7.486 18.942 9.301" />
      <path stroke="currentColor" strokeLinecap="round" d="m2.359 7.772 20.064 9.852" />
    </SvgIcon>
  )
}

export default Icon
